// Labels and colors keyed by the REAL DB enum values (see
// supabase/migrations/004_orders.sql). No forward-compat aliases — the
// helpers below produce a neutral fallback for any unknown value, so the UI
// still renders something sensible if the enum is extended in the future.
import type {
  PaymentMethod,
  PaymentStatus,
} from "@/lib/admin-api/payment";

export const METHOD_LABELS: Record<PaymentMethod, string> = {
  wave: "Wave",
  orange_money: "Orange Money",
  cash_on_delivery: "Espèces / COD",
};

export const METHOD_COLORS: Record<PaymentMethod, string> = {
  wave: "bg-blue-100 text-blue-800",
  orange_money: "bg-orange-100 text-orange-800",
  cash_on_delivery: "bg-stone-100 text-stone-700",
};

export const STATUS_COLORS: Record<PaymentStatus, string> = {
  pending: "bg-amber-100 text-amber-800",
  confirmed: "bg-emerald-100 text-emerald-800",
  failed: "bg-red-100 text-red-800",
};

export const STATUS_LABELS: Record<PaymentStatus, string> = {
  pending: "En attente",
  confirmed: "Confirmé",
  failed: "Échoué",
};

// Neutral badge for unknown values so cells never render blank when the DB
// enum is extended before the UI catches up.
export const UNKNOWN_BADGE_CLASS = "bg-stone-100 text-stone-600";

export function getMethodLabel(method: string | null | undefined): string {
  if (!method) return "—";
  return METHOD_LABELS[method as PaymentMethod] ?? method;
}

export function getMethodClass(method: string | null | undefined): string {
  if (!method) return UNKNOWN_BADGE_CLASS;
  return METHOD_COLORS[method as PaymentMethod] ?? UNKNOWN_BADGE_CLASS;
}

export function getStatusLabel(status: string | null | undefined): string {
  if (!status) return "—";
  return STATUS_LABELS[status as PaymentStatus] ?? status;
}

export function getStatusClass(status: string | null | undefined): string {
  if (!status) return UNKNOWN_BADGE_CLASS;
  return STATUS_COLORS[status as PaymentStatus] ?? UNKNOWN_BADGE_CLASS;
}

// ---------------------------------------------------------------------------
// Tab types
// ---------------------------------------------------------------------------

export type TabId = "transactions" | "mobile_money" | "cod_trust" | "analytics";

export interface Tab {
  readonly id: TabId;
  readonly label: string;
  readonly icon: React.ReactNode;
}
